import { Component, OnInit, Input, TemplateRef, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { environment } from "../../../../environments/environment";
import * as momentTz from 'moment-timezone';
import { UserService } from "../../../_services/cs/user.service";

declare let moment: any;
declare let toastr: any;

@Component({
    selector: "user-profile",
    templateUrl: "user-profile.component.html",
    styleUrls: ['user-profile.component.scss']
})
export class UserProfileComponent implements OnInit {

    @Input() userInfo: any;

    @ViewChild('welcomeQuestModal') welcomeQuestModal: TemplateRef<any>;

    welcomeQuestModalRef: NgbModalRef = null;
    welcomeQuestLoading = false;
    welcomeQuestStatus: { version: number, startedAt: string } = null;
    welcomeQuestVersions: any[] = null;
    selectedWelcomeQuestVersion: number = null;
    welcomeQuestPending = false;

    // 웰컴퀘스트는 한국 전용 기능이므로 한국 스튜디오에서만 노출한다.
    public lang = environment.language;

    // 웰컴퀘스트 대상자 기간 (api 와 동일한 상수)
    private readonly WELCOME_QUEST_DAYS = 7;

    constructor(
        private http: HttpClient,
        private userService: UserService,
        private router: Router,
        private modalService: NgbModal,
    ) { }

    ngOnInit() {

    }

    resetProfileTime() {
        this.http
            .patch(`user/profile/updatedat`, {
                userId: this.userInfo.id
            })
            .toPromise()
            .then(((r) => {
                this.userInfo.UserProfile.modified_at = moment().subtract(7, "days");
                toastr.success('프로필 수정 시간을 7일 전으로 돌려놓았습니다.');
            }))
            .catch(err => {
                toastr.error('실패하였습니다.');
                console.error(err);
            })
    }

    changeCountry(event) {
        let value = event;
        this.http.patch('user/country', {
            id: this.userInfo.id,
            transfer: value
        })
            .toPromise()
            .then((() => {
                value ? toastr.success('이제 해당 유저는 설정에서 국가를 변경할 수 있습니다.') : toastr.warning('이제 해당 유저는 설정에서 국가를 변경할 없습니다.');
            }))
            .catch(err => {
                toastr.error('실패하였습니다.');
                console.error(err);
            })
    }

    changeAdmin() {
        this.http.patch('user/id', {
            user: {
                id: this.userInfo.id,
                admin: !this.userInfo.admin
            }
        })
            .toPromise()
            .then(() => {
                toastr.success(`${this.userInfo.id} 계정 admin ${this.userInfo.admin ? '해제' : '설정'}됨`);
                this.userInfo.admin = this.userInfo.admin ? 0 : 1;
            })
            .catch(e => {
                console.log(e);
                toastr.error('실패');
            })
    }

    openFas(type) {
        const up = this.userInfo.UserProfile;
        if (type === 'sazoo') {
            const ymdh = momentTz(up.birth_in_millis).tz(up.City.timezone_id).format("YYYYMMDDHHmm"); // 199005301200
            const en = environment.language === 'en' ? 'app-en.' : '';
            const url = `https://${en}forceteller.com/admin/client/show_v2?ymdh=${ymdh}&calendar=${up.calendar}&gender=${up.gender}&locationId=${up.location_id}&name=${encodeURIComponent(this.userInfo.name)}`;
            window.open(url, '_blank');
        } else if (type === 'astro') {
            const url = `https://astro-fas.forceteller.com/?geonameId=${up.location_id}&tm=${up.birth_in_millis}&name=${encodeURIComponent(this.userInfo.name)}&hmUnsure=${up.hm_unsure ? 1 : 0}`
            window.open(url, '_blank');
        }
    }

    resetOnborarding() {
        const email = this.userInfo.email;
        const userId = this.userInfo.id
        this.userService.resetOnboarding({ body: { email: email, userId: userId } })
            .then(() => {
                toastr.success('초기화에 성공하였습니다.');
            })
            .catch(() => {
                toastr.error('초기화에 실패하였습니다.');
            });
    }

    // 열 때마다 현재 배정 + 버전 목록을 새로 조회한다. (초기화 후 다시 열면 새 배정이 보인다)
    openWelcomeQuestModal() {
        // userInfo 로딩 전이면 대상 유저를 특정할 수 없으므로 열지 않는다.
        if (!this.userInfo || !this.userInfo.id) {
            return;
        }
        this.welcomeQuestStatus = null;
        this.welcomeQuestVersions = null;
        this.selectedWelcomeQuestVersion = null;
        this.welcomeQuestLoading = true;
        // 초기화 요청 중에는 ESC/배경 클릭으로 닫히지 않게 한다.
        this.welcomeQuestModalRef = this.modalService.open(this.welcomeQuestModal, {
            centered: true,
            beforeDismiss: () => !this.welcomeQuestPending
        });

        Promise.all([
            this.userService.getWelcomeQuestStatus(this.userInfo.id),
            this.userService.getWelcomeQuestVersions()
        ])
            .then(([status, versions]) => {
                if (!versions || !versions.length) {
                    this.closeWelcomeQuestModal();
                    toastr.error('웰컴퀘스트 버전 목록이 비어 있습니다.');
                    return;
                }
                this.welcomeQuestStatus = status || null;
                this.welcomeQuestVersions = versions;
                this.selectedWelcomeQuestVersion = this.getDefaultWelcomeQuestVersion();
                this.welcomeQuestLoading = false;
            })
            .catch(() => {
                this.closeWelcomeQuestModal();
                toastr.error('웰컴퀘스트 정보를 불러오지 못하였습니다.');
            });
    }

    closeWelcomeQuestModal() {
        if (this.welcomeQuestModalRef) {
            this.welcomeQuestModalRef.close();
            this.welcomeQuestModalRef = null;
        }
    }

    // "2026-07-23 14:05 ~ 2026-07-30 14:05" — 배정 시각부터 7일간이 대상자 기간이다.
    welcomeQuestPeriodLabel(): string {
        const startedAt = momentTz(this.welcomeQuestStatus.startedAt).tz('Asia/Seoul');
        const endedAt = startedAt.clone().add(this.WELCOME_QUEST_DAYS, 'days');
        return `${startedAt.format('YYYY-MM-DD HH:mm')} ~ ${endedAt.format('YYYY-MM-DD HH:mm')}`;
    }

    isWelcomeQuestPeriodEnded(): boolean {
        return momentTz(this.welcomeQuestStatus.startedAt).add(this.WELCOME_QUEST_DAYS, 'days').isBefore(momentTz());
    }

    // 버전 목록은 version 내림차순이므로, 이미 릴리즈된 것 중 처음 만나는 것이 최신 버전이다. (api 자동 배정 로직과 동일 기준)
    private getDefaultWelcomeQuestVersion(): number {
        if (!this.welcomeQuestVersions.length) {
            return null;
        }
        const released = this.welcomeQuestVersions.find(v => v.availableStartedAt && new Date(v.availableStartedAt) <= new Date());
        return (released || this.welcomeQuestVersions[0]).version;
    }

    welcomeQuestVersionLabel(version: any): string {
        // 기본 선택은 최신 릴리즈 버전이므로, 현재 배정 버전과 다를 수 있다. 어느 쪽이 현재 배정인지 표시해준다.
        const current = Number(version.version) === Number(this.welcomeQuestStatus?.version) ? ' — 현재 배정' : '';
        if (!version.availableStartedAt) {
            return `v${version.version} (release 일시 없음)${current}`;
        }
        const releasedAt = momentTz(version.availableStartedAt).tz('Asia/Seoul').format('YYYY-MM-DD HH:mm');
        const scheduled = new Date(version.availableStartedAt) > new Date();
        return `v${version.version} (release${scheduled ? ' 예정' : ''} ${releasedAt})${current}`;
    }

    resetWelcomeQuest() {
        if (this.welcomeQuestPending) {
            return;
        }
        const version = Number(this.selectedWelcomeQuestVersion);
        if (isNaN(version) || this.selectedWelcomeQuestVersion === null) {
            toastr.error('초기화할 버전을 선택해주세요.');
            return;
        }
        if (!confirm('초기화 하시겠습니까?')) {
            return;
        }
        this.welcomeQuestPending = true;
        this.userService.resetWelcomeQuest({ body: { userId: this.userInfo.id, version: version } })
            .then(() => {
                this.closeWelcomeQuestModal();
                toastr.success(`웰컴퀘스트를 v${version}(으)로 초기화하였습니다.`);
            })
            .catch(() => {
                toastr.error('웰컴퀘스트 초기화에 실패하였습니다.');
            })
            .then(() => {
                this.welcomeQuestPending = false;
            });
    }

    // 종료 = 배정과 진행 기록을 전부 지운다. 재배정은 하지 않는다.
    endWelcomeQuest() {
        if (this.welcomeQuestPending) {
            return;
        }
        if (!confirm('웰컴퀘스트를 종료하시겠습니까? 배정과 진행 기록이 모두 삭제됩니다.')) {
            return;
        }
        this.welcomeQuestPending = true;
        this.userService.endWelcomeQuest({ body: { userId: this.userInfo.id } })
            .then(() => {
                // 배정을 지웠으므로 현재 배정은 없는 상태다. 모달은 열어둔 채 갱신한다.
                this.welcomeQuestStatus = null;
                toastr.success('종료되었습니다.');
            })
            .catch(() => {
                toastr.error('웰컴퀘스트 종료에 실패하였습니다.');
            })
            .then(() => {
                this.welcomeQuestPending = false;
            });
    }
}
